module.exports = __webpack_public_path__ + "static/img/logo.27934a34.svg";